import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button } from '@mui/material';
import { Refresh, AccessTime } from '@mui/icons-material';
import { toast } from 'react-toastify';
import { GeneralError } from '../../Utility/Constants';
import { getCocaAnnual1ReportData, clearData } from '../../Redux/CocaAnnualReports/CocaAnnual1Slice';
import ReportsTable from '../../Table/ReportsTable';
import Spinner from '../../Spinner/Spinner';
import { CocaExportBySnenarioColumns } from '../../Table/TableColumn';
import CocaCarrier from '../../CocaAnnualReports/CocaCarrier';

function CocaAnnual1() {
    const dispatch = useDispatch();
    const isLoadDataLoading = useSelector(state => state.cocaAnnual1.COCAByScenarioData.loading);
    const loadDataError = useSelector(state => state.cocaAnnual1.COCAByScenarioData.error);
    const lastRefreshedDate = useSelector(state => state.cocaAnnual1.COCAByScenarioData.lastRefreshedDate);
    const [initialFetchDone, setInitialFetchDone] = useState(false);

    useEffect(() => {
        if (loadDataError) {
            toast.error(GeneralError);
        }
    }, [loadDataError]);

    const handleRefresh = () => {
        dispatch(getCocaAnnual1ReportData());
    };

    useEffect(() => {
        dispatch(clearData());
        dispatch(getCocaAnnual1ReportData()).finally(() => setInitialFetchDone(true));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            {(!initialFetchDone && isLoadDataLoading) && <Spinner />}
            <Box sx={{ margin: '20px 0' }}>
                <CocaCarrier tabIndex={0} />
            </Box>
            <Box sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                paddingBottom: '16px',
                gap: 2
            }}>
                <Button
                    variant="outlined"
                    size="small"
                    disabled={true}
                    startIcon={<AccessTime />}
                    sx={{ minWidth: '180px', fontWeight: 'bold' }}
                >
                    {`Last Updated: ${lastRefreshedDate ? lastRefreshedDate.split('.')[0] : ''}`}
                </Button>
                <Button
                    variant="outlined"
                    size="small"
                    onClick={handleRefresh}
                    disabled={isLoadDataLoading}
                    startIcon={<Refresh />}
                    sx={{ minWidth: '120px', fontWeight: 'bold' }}
                >
                    {isLoadDataLoading ? 'Refreshing...' : 'Refresh'}
                </Button>
            </Box>
            <ReportsTable
                tableName={'Scenario Details'}
                tableIndex={0}
                columns={CocaExportBySnenarioColumns}
                dataSource={'COCAByScenarioData'}
                loading={isLoadDataLoading}
                sliceName={'cocaAnnual1'}
            />
        </>
    );
}

export default CocaAnnual1;